import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderMobileSearchHistoryNotification = (onClose?: Parameters<typeof openPopupHelper>[0]['onClose']) =>
    openPopupHelper({ popupName: popupNames.MOBILE_SEARCH_HISTORY_NOTIFICATION, onClose });
